import { Horarios } from "../../../domain/models/Pines";
import { ActionType } from "../ActionsTypes";
import { ReducerAction } from '../ReducerAction';
import { PinesState } from '../states/PinesUsuariosState';

export const pinesReducer = (state = new PinesState({
    pinesUsuarios: [],
    pinesHorarios: new Horarios({})
}), action: ReducerAction) => {

    switch (action.type) {
        case ActionType.LIST_PINES_USUARIOS:
            return new PinesState({
                ...state,
                pinesUsuarios: action.payload
            });

        case ActionType.LIST_PINES_HORARIOS:
            return new PinesState({
                ...state,
                pinesHorarios: action.payload
            });

        default: return state;
    }
}